// extracted by mini-css-extract-plugin
module.exports = {"idleModalButtons":"styles_idleModalButtons__RIDA2","modalTime":"styles_modalTime__T7DVu"};